import { UomsDto  } from "@gtpl/shared-models/masters";
import { GlobalResponseObject } from '@gtpl/shared-models/common-models';


export class AllUomsResponseModel extends GlobalResponseObject {
    data?: UomsDto[];
    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data /ProductDto[]
     */
     constructor(status: boolean, errorCode: number, internalMessage: string, data?: UomsDto[]) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}

